import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { ColorModePropKeys } from 'src/app/styles/colors';
import { cssVar } from 'src/app/styles/helper';
import { SpacingProps } from 'src/app/atoms/Layout/Spacing.styles';

export interface BadgeProps extends SpacingProps {
  label: string;
  color: 'gray' | 'brand' | 'error' | 'warning' | 'success';
  noWrap?: boolean;
}

type BadgeColor = {
  text: ColorModePropKeys;
  background: ColorModePropKeys;
  border: ColorModePropKeys;
};

const badgeColors: Record<string, BadgeColor> = {
  gray: {
    text: 'text-secondary',
    background: 'gray-light-50',
    border: 'gray-light-200',
  },
  brand: {
    text: 'text-brand-secondary',
    background: 'brand-50',
    border: 'brand-200',
  },
  error: {
    text: 'error-700',
    background: 'error-50',
    border: 'error-200',
  },
  warning: {
    text: 'warning-700',
    background: 'warning-50',
    border: 'warning-200',
  },
  success: {
    text: 'success-700',
    background: 'success-50',
    border: 'success-200',
  },
};

const Badge = ({ label, color, noWrap = false, ...spacingProps }: BadgeProps): JSX.Element => (
  <Stack
    borderRadius='radius-full'
    background={badgeColors[color].background}
    border={`1px solid ${cssVar(badgeColors[color].border)}`}
    padding={['spacing-xxs', 'spacing-md']}
    {...spacingProps}
  >
    <Typography
      type='paragraph'
      size='sm'
      color={badgeColors[color].text}
      fontWeight='font-weight-medium'
      whiteSpace={noWrap ? 'nowrap' : undefined}
    >
      {label}
    </Typography>
  </Stack>
);

export default Badge;
